/**
 * 학생 정보 조회
 */
import React, { Component } from 'react';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert } from '../../common/common';
import { hakgwaList, stdtInfo as getStdtInfo } from '../../common/usr/stdtList';
import { Navbar, Row, Col, Button, Form } from 'react-bootstrap';
import $ from 'jquery';
import loader from '../../imgs/ajax-loader.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowCircleLeft, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { dropByCacheKey } from 'react-router-cache-route'

let that = this;

class StdtInfoCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,
      validated: false,
      stdtInfo: getStdtInfo,
      usrInfo: null,
    }
  }

  componentWillMount = () => {
    this.setState({
      stdtInfo: getStdtInfo,
      validated: false,
    });
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data });
      } else {
        this.props.history.push('/');
      }
    });
  }

  // 휴대전화번호 양식 체크
  fn_chkPhoneFormat = (gu, val) => {
    let guNm = '휴대전화-학생';
    if (gu === 'PRT') guNm = '휴대전화-학부모';

    const regExp = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
    if (val !== '' && !regExp.test(val)) {
      openAlert(this, '[' + guNm + '] 잘못된 휴대폰 번호입니다. 숫자, - 를 포함한 숫자만 입력하세요.');
      return false;
    }

    return true;
  }

  // form submit
  handleSubmit(event) {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (/[^0123456789.]/g.test($('#I_BAN').val())) {
      openAlert(this, '숫자가 아닙니다.\n\n0-9의 정수만 허용합니다.');
      $('#I_BAN').val('');
      return false;
    }

    if (/[^0123456789.]/g.test($('#I_BUN').val())) {
      openAlert(this, '숫자가 아닙니다.\n\n0-9의 정수만 허용합니다.');
      $('#I_BUN').val('');
      return false;
    }

    if (!this.fn_chkPhoneFormat('STD', $('#I_HP_STD').val())) return false;
    if (!this.fn_chkPhoneFormat('PRT', $('#I_HP_PRT').val())) return false;
    if (!this.fn_chkPhoneFormat('PRT', $('#I_HP_PRT2').val())) return false;

    if (form.checkValidity()) {
      this.udfUpdateStdtInfo();
    }

    this.setState({ validated: true });
  }

  udfUpdateStdtInfo = () => {
    if (!this.state.usrInfo) return;
    udfInlineLoading();

    const sendData = {
      isMobile: 'Y',
      HAKGWA: $('#I_HAKGWA').val() === '' ? $('#ID_HAKGWA').val() : $('#I_HAKGWA').val(),
      GRADE: $('#I_GRADE').val(),
      BAN: $('#I_BAN').val(),
      BUN: $('#I_BUN').val(),
      STD_NM: $('#I_STD_NM').val(),
      STD_STATUS: this.state.stdtInfo.STD_STATUS,
      HP_STD: $('#I_HP_STD').val(),
      HP_PRT: $('#I_HP_PRT').val(),
      HP_PRT2: $('#I_HP_PRT2').val(),
      OTHER_CD: this.state.stdtInfo.OTHER_CD,
      STD_CD: this.state.stdtInfo.STD_CD,
    };

    that = this;

    $.ajax({
      url: url + '/sli/stdt/updateStdt.do',
      type: 'GET',
      dataType: 'jsonp',
      data: sendData,
      success: function (data) {
        udfNoneLoading();

        if (!data.success)
          that.componentDidMount();
        else {
          if (data.result <= 0) {
            openAlert(that, '오류가 발생했습니다. 다시 시도해주세요.');
          } else {
            dropByCacheKey('stdtRuleHistoryCachce');
            openAlert(that, '저장되었습니다.', function () {
              that.props.history.go(-1);
            });
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  phone_format = (type, num) => {
    if (type === 1) {
      return num.replace(/([0-9]{4})([0-9]{4})/, '$1-$2');
    } else if (type === 2) {
      return num.replace(/([0-9]{2})([0-9]+)([0-9]{4})/, '$1-$2-$3');
    } else if (type === 3) {
      return num.replace(/([0-9]{3})([0-9]{4})/, '$1-$2');
    } else {
      return num.replace(/(^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
        '$1-$2-$3');
    }
  };

  fn_chk_tel = (target) => {
    if (this.fn_chkPhoneFormat(target.name.split('-')[2], target.value)) {
      let value = target.value;
      let len = value.length;

      if (len === 7) {
        value = this.phone_format(3, value);
      } else if (len === 8) {
        value = this.phone_format(1, value);
      } else if (len === 10) {
        value = this.phone_format(4, value);
      } else if (len === 11) {
        value = this.phone_format(4, value);
      }

      $('#' + target.name).val(value);
    }
  };

  render() {
    const setHakgwaList = hakgwaList.map((str, idx) => (
      <option value={str} key={idx}>{str}</option>
    ));

    return (
      <>
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className='goBackBtn'><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className='btn-home' /></div></div>
          <div>
            {this.state.stdtInfo.HAKGWA}{this.state.stdtInfo.HAKGWA !== undefined ? ' ' + this.state.stdtInfo.GRADE : this.state.stdtInfo.GRADE}-{this.state.stdtInfo.BAN}-{this.state.stdtInfo.BUN} {this.state.stdtInfo.STD_NM}
          </div>
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ marginBottom: '4rem', marginTop: '65px' }}>
          <Form
            id='stdtFrm'
            className='m-0 p-0'
            noValidate
            validated={this.state.validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            <Row className='ml-0 mr-0'>
              <Col className='pl-0'>
                <Form.Group controlId='I_HAKGWA'>
                  <Form.Label>학과</Form.Label>
                  <Form.Control as='select' name='I_HAKGWA' className="bg-light" defaultValue={this.state.stdtInfo.HAKGWA} onChange={e => $('#ID_HAKGWA').val(e.target.value)}>
                    <option value=''>직접입력</option>
                    {setHakgwaList}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col className='pr-0'>
                <Form.Group controlId='ID_HAKGWA'>
                  <Form.Label>&nbsp;</Form.Label>
                  <Form.Control type='text' className="bg-light" defaultValue={this.state.stdtInfo.HAKGWA} name='ID_HAKGWA' />
                </Form.Group>
              </Col>
            </Row>
            <Row className='ml-0 mr-0'>
              <Col className='pl-0'>
                <Form.Group controlId='I_GRADE'>
                  <Form.Label>학년</Form.Label>
                  <Form.Control as='select' name='I_GRADE' className="bg-light" defaultValue={this.state.stdtInfo.GRADE} required>
                    <option value='1'>1 학년</option>
                    <option value='2'>2 학년</option>
                    <option value='3'>3 학년</option>
                    <option value='4'>4 학년</option>
                    <option value='5'>5 학년</option>
                    <option value='6'>6 학년</option>
                  </Form.Control>
                  <Form.Control.Feedback type='invalid'>
                    학년을 선택해주세요.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col className='pl-0'>
                <Form.Group controlId='I_BAN'>
                  <Form.Label>반</Form.Label>
                  <Form.Control type='number' name='I_BAN' className="bg-light" defaultValue={this.state.stdtInfo.BAN} required />
                  <Form.Control.Feedback type='invalid'>
                    반(숫자)을 입력해주세요.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col className='pl-0 pr-0'>
                <Form.Group controlId='I_BUN'>
                  <Form.Label>번호</Form.Label>
                  <Form.Control type='number' name='I_BUN' className="bg-light" defaultValue={this.state.stdtInfo.BUN} required />
                  <Form.Control.Feedback type='invalid'>
                    번호(숫자)를 입력해주세요.
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId='I_STD_NM'>
              <Form.Label>이름</Form.Label>
              <Form.Control type='text' name='I_STD_NM' className="bg-light" defaultValue={this.state.stdtInfo.STD_NM} required />
              <Form.Control.Feedback type='invalid'>
                이름을 입력해주세요.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId='I_HP_STD'>
              <Form.Label>휴대전화-학생</Form.Label>
              <Form.Control
                type='text'
                name='I_HP_STD'
                className="bg-light"
                defaultValue={this.state.stdtInfo.HP_STD}
                onBlur={e => this.fn_chk_tel(e.target)}
              />
            </Form.Group>
            <Form.Group controlId='I_HP_PRT'>
              <Form.Label>휴대전화-학부모1</Form.Label>
              <Form.Control
                type='text'
                name='I_HP_PRT'
                className="bg-light"
                defaultValue={this.state.stdtInfo.HP_PRT}
                onBlur={e => this.fn_chk_tel(e.target)}
              />
            </Form.Group>
            <Form.Group controlId='I_HP_PRT2'>
              <Form.Label>휴대전화-학부모2</Form.Label>
              <Form.Control
                type='text'
                name='I_HP_PRT2'
                className="bg-light"
                defaultValue={this.state.stdtInfo.HP_PRT2}
                onBlur={e => this.fn_chk_tel(e.target)}
              />
            </Form.Group>
            <div className='text-secondary' style={{ fontSize: '.9rem' }}>{this.state.stdtInfo.LAST_UPDATE}</div>
            <Button type='submit' className='mt-2 btn btn-height btn-school-life col'>저장</Button>
          </Form>
        </div>
      </>
    );
  }
}

export default StdtInfoCmp;